import { Device, DeviceType, OsType } from '../models/browser-detection';

export class MobileDetection {
  public static isMobile(): boolean {
    return /Android|webOS|CriOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
}

export const isMobileBrowser = (userAgent: string): '' | DeviceType | null => {
  const android = () => userAgent.match(/Android/i);
  const blackBerry = () => userAgent.match(/BlackBerry/i);
  const iOS = () => userAgent.match(/iPhone|iPad|iPod/i);
  const opera = () => userAgent.match(/Opera Mini/i);
  const windows = () => userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);

  return ((android() && DeviceType.android) || (blackBerry() && DeviceType.android) || (iOS() && DeviceType.ios) || (opera() && DeviceType.android) || (windows() && DeviceType.android));
};

const getOs = (): OsType => {
  return navigator.appVersion.indexOf('Win') !== -1
    ? OsType.windows : navigator.appVersion.indexOf('Mac') !== -1
      ? OsType.mac : navigator.appVersion.indexOf('X11') !== -1
        ? OsType.unix : navigator.appVersion.indexOf('Linux') !== -1
          ? OsType.linux : OsType.unknown;
};

export const detectDevice = (userAgent: string): Device => {
  const browsersKey: Record<string, string> = {
    coc_coc_browser: 'Cốc Cốc',
    UBrowser: 'UC Browser',
    UCBrowser: 'UC Browser',
    Maxthon: 'Maxthon',
    Edge: 'Edge',
    Trident: 'Internet Explorer',
    Firefox: 'Firefox',
    OPR: 'Opera',
    Opera: 'Opera',
    Chrome: 'Chrome',
    Safari: 'Safari',
  };
  const parsedUserAgent = Object.keys(browsersKey).find(key => userAgent.includes(key));
  return {
    type: isMobileBrowser(userAgent) || DeviceType.desktop,
    browser: browsersKey[parsedUserAgent || Object.keys(browsersKey)[0]],
    os: getOs(),
    label: 'common.label.unknown-browser'
  };
};
